/* eslint-disable react-hooks/rules-of-hooks */
import { ExtraIgnoreItem, FieldMappingResponseDto, MaskingRule, PrimaryClassification, SecondaryClassificationResponseDto } from "@/gen/api/governance";
import { ZUtils } from "./FieldsMappingList.col.validate";
import { Autocomplete, TextField } from "@mui/material";
import { SimpleOption } from "@/components/governance/search/AmbientFacilitiesContext";
import { adjustErrorHelperText, couplingValidationRequest, E_FieldMapping, emsChangePayload, ET_FieldMapping } from "./FieldsMappingList.events";
import { useEventBus } from "@/contexts/EventBusContext/useEventBus";



interface ClassificationColumnProps {
  fieldDto: FieldMappingResponseDto;
  utils: ZUtils['utils'],
  plainStateUtils: ZUtils['plainStateUtils'],
  hasWritePermit: boolean;
  encryptSettingChangeLocked?: boolean | undefined;
  classificationSelectOptions: SimpleOption[];
}

const ClassificationColumn = function ({
  fieldDto, utils, plainStateUtils, hasWritePermit, classificationSelectOptions, encryptSettingChangeLocked,
}: ClassificationColumnProps
) {
  const { setStates, states } = utils
  const { fieldProps, commonMutate } = plainStateUtils ?? {}
  
  const selectedClss = (() => {
    const sndClsId = states?.stage.secondaryClassificationId || -1
    return (classificationSelectOptions.find(c => c.key === sndClsId) as any) as SimpleOption || null
  })();

  const cvr = couplingValidationRequest(states)
  const { error, helperText } = adjustErrorHelperText(states, 'secondaryClassificationId', fieldProps, cvr.C)
  const eventBus = useEventBus('fields-mapping-list')

  return (
    <Autocomplete 
      disabled={!hasWritePermit || encryptSettingChangeLocked}
      disableClearable={true}
      options={classificationSelectOptions}
      getOptionLabel={(option) => option ? (option.text || '') : ''}
      value={selectedClss}
      
      renderInput={((params) =>
        <TextField {...params} fullWidth size="small" 
          error={error}
          helperText={helperText}
          {...{
            inputProps: {
              ...params.inputProps,
              'aria-label': 'Classification',
            }
          }}
        />
      )}
      onChange={(event, value, reason) => {
        if (hasWritePermit && reason === 'selectOption' && fieldDto.fieldId) {
          if ((value as any)?.value === null) { // choosed '[None]'
            setStates?.(v => {
              if (!commonMutate) return v;
              let v1 = {...v}
              v1.stage.primaryClassification = undefined
              v1.stage.isSkipped = true
              v1.stage.encryptionRuleId = null
              v1.stage.maskingRule = MaskingRule.None
              v1.stage.maskingValue = ''
              v1.errors = {}
              v1.touched = {}
              v1 = commonMutate('secondaryClassificationId', undefined)(v1)
              eventBus.publish(E_FieldMapping.EncryptMappingStatusChange,
                [emsChangePayload(fieldDto, v1.stage)] as ET_FieldMapping['encrypt_mapping_status_change'])
              return v1
            })
          } else {
            const cls1 = value as SecondaryClassificationResponseDto
            setStates?.(v => {
              if (!commonMutate) return v;
              let v1 = {...v}
              v1.stage.primaryClassification = cls1.primaryClassification
              if (fieldDto.isIdentity || fieldDto.isComputed || fieldDto.extraIgnoreItem !== ExtraIgnoreItem.None) { 
                v1.stage.isSkipped = true 
              }
              v1 = commonMutate('secondaryClassificationId', cls1.secondaryClassificationId)(v1)
              if (cls1.primaryClassification === PrimaryClassification.Public) {
                v1.stage.isSkipped = true
                v1.stage.maskingValue = ''
                v1 = (
                  commonMutate('encryptionRuleId', null)(
                    commonMutate('maskingRule', MaskingRule.None)(
                      v1)))
              }
              eventBus.publish(E_FieldMapping.EncryptMappingStatusChange,
                [emsChangePayload(fieldDto, v1.stage)] as ET_FieldMapping['encrypt_mapping_status_change'])
              return v1
            })
          }
        }
      }}
    />
  )
}

export default ClassificationColumn;

